import { useNavigate } from 'react-router-dom';
import { LoginButton } from './LoginButton';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export const LoginPage = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) return null;

  return <LoginButton />;
};
